import { createContext, ReactNode, useMemo } from 'react';
import { useFileAnalyticsWorkflow } from './hooks/useFileAnalyticsWorkflow';
import { FileParser } from './types';

interface MappingAnalyticsContextProps {
  isLoadingWorkflowId: boolean;
  workflowId: string | undefined;
  isStaleWorkflow: boolean;
}

export const FileAnalyticsContext = createContext({} as MappingAnalyticsContextProps);

export const FileAnalyticsProvider = ({ fileParser, children }: { fileParser?: FileParser; children: ReactNode }) => {
  const { isLoading: isLoadingWorkflowId, workflowId, isStaleWorkflow } = useFileAnalyticsWorkflow(fileParser);

  const contextValue = useMemo(
    () => ({ isLoadingWorkflowId, workflowId, isStaleWorkflow }),
    [isLoadingWorkflowId, workflowId, isStaleWorkflow]
  );

  return <FileAnalyticsContext value={contextValue}>{children}</FileAnalyticsContext>;
};
